import { useQuery } from '@tanstack/react-query';
import { memberInfoKey, requestMyMemberInfo } from '@/hooks/member/memberInfoApi';
import { mapToBillingProfile } from './billingApi';

/**
 * Billing-address prefill for the Add Payment Account modal, read off the member's own profile.
 * Shares the `myMemberInfo` query/cache with {@link useMemberAutoPaySummary} — same key, different
 * `select` — so mounting both doesn't fire the query twice.
 */
export function useMemberBillingProfile() {
  return useQuery({
    queryKey: memberInfoKey,
    queryFn: requestMyMemberInfo,
    select: mapToBillingProfile,
  });
}
